import "../assets/NewsDetail.css";

import { useEffect, useState } from "react";

import NewsSingle from "../services/newsSingle";
import { Box, Container, Grid, Skeleton, Typography } from "@mui/material";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaPaperPlane,
  FaShareFromSquare,
} from "react-icons/fa6";
import NewsDetailLoading from "./loading/NewsDetailLoading";
import { apiClient } from "../services/ApiClient";
import { useParams } from "react-router-dom";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
} from "react-share";
import { blogUrl } from "../services/AppVariables";

const NewsDetail = () => {
  const { blogSlug } = useParams();

  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copyLinkAlert, setCopyLinkAlert] = useState(false);

  const handleCopyLink = (link) => {
    setCopyLinkAlert(true);

    navigator.clipboard.writeText(link);

    setTimeout(() => setCopyLinkAlert(false), 1000);
  };

  const getNews = async () => {
    setLoading(true);
    const res = await apiClient
      .get("news/index/" + blogSlug)
      .catch((error) => console.error(error));

    const news_data = Object.values(res.data);

    setNews(news_data);

    // setNews(Object.values(NewsSingle));

    setLoading(false);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    getNews();
  }, []);

  if (loading) {
    return <NewsDetailLoading />;
  }

  return (
    <Container
      maxWidth="xl"
      sx={{
        maxWidth: "1700px !important",
        pl: "0px !important",
        pr: "0px !important",
      }}
    >
      <Box className="gr-blog-detail-header-bg">
        <Box className="gr-blog-detail-header">
          <Grid container spacing={6}>
            <Grid item lg={7} sm={12} xs={12}>
              <Box className="gr-blog-detail-image">
                <img
                  src={"https://ganzrund.com/" + news[0].files[0].publicUrl}
                  className="gr-blog-featured-image"
                  alt="Placeholder"
                />
              </Box>
            </Grid>
            <Grid item lg={5} sm={12} xs={12}>
              <Box className="gr-blog-detail-meta-content">
                <Box className="gr-blog-detail-meta-head">
                  <Box className="gr-blog-meta-data">
                    <Typography className="gr-blog-meta-category">
                      {news[0].categories[0]}
                    </Typography>{" "}
                    <Typography sx={{ display: "inline" }}>
                      - {news[0].news.crdate}{" "}
                    </Typography>
                    <Typography className="gr-blog-meta-read-time-patch">
                      {news[0].news.readtime}min lesen
                    </Typography>
                  </Box>
                  <Box className="gr-blog-detail-title">
                    <Typography
                      sx={{ fontSize: "35px !important" }}
                      component="h1"
                    >
                      {news[0].news.title}
                    </Typography>
                  </Box>
                </Box>
                <Box className="gr-blog-detail-meta-footer">
                  <Box className="gr-blog-author">
                    <Box className="gr-blog-author-avatar">
                      <img
                        src={
                          news[0].news.author === "Chiara erklärt"
                            ? "https://ganzrund.com/fileadmin/user_upload/chiara.jpg"
                            : "https://ganzrund.com/_assets/7bd9c8c8de0c98603b46240c0ed70db7/Images/fav.jpg"
                        }
                      />
                    </Box>
                    <Typography>
                      {news[0].news.author === "Chiara erklärt"
                        ? "von Chiara"
                        : "GANZRUND Team"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="gr-blog-detail-content">
        <Grid container spacing={6}>
          <Grid item lg={4} sm={12} xs={12}>
            <Box className="gr-blog-detail-share">
              <p>Artikel teilen</p>
              <Box className="gr-blog-detail-share-list">
                <Box className="gr-blog-detail-share-item">
                  <FacebookShareButton
                    url={"https://ganzrund.com" + blogUrl + "/" + blogSlug}
                  >
                    <FaFacebookF />
                  </FacebookShareButton>
                </Box>
                <Box className="gr-blog-detail-share-item">
                  <LinkedinShareButton
                    url={"https://ganzrund.com" + blogUrl + "/" + blogSlug}
                  >
                    <FaLinkedinIn />
                  </LinkedinShareButton>
                </Box>
                <Box className="gr-blog-detail-share-item">
                  <EmailShareButton
                    size={40}
                    subject={"GANZRUND-Blog | " + news[0].news.title}
                    url={"https://ganzrund.com" + blogUrl + "/" + blogSlug}
                    body="Sie dir diesen Beitrag an: "
                    separator=""
                  >
                    <FaPaperPlane />
                  </EmailShareButton>
                </Box>
                <Box
                  className="gr-blog-detail-share-item"
                  onClick={() =>
                    handleCopyLink(
                      "https://ganzrund.com" + blogUrl + "/" + blogSlug
                    )
                  }
                >
                  <FaShareFromSquare />
                </Box>
              </Box>
              {copyLinkAlert ? (
                <Typography sx={{ mt: 2 }}>Link wurde kopiert!</Typography>
              ) : null}
            </Box>
          </Grid>
          <Grid item lg={8} sm={12} xs={12}>
            <Box
              className="gr-blog-detail-content-inner-text"
              dangerouslySetInnerHTML={{ __html: news[0].news.bodytext }}
            />
            {news[0].news.relation_service_link !== null ? (
              <Box id="request-button-area">
                <a
                  className="read-more"
                  href={news[0].news.relation_service_link}
                >
                  {news[0].news.relation_service_text !== null
                    ? news[0].news.relation_service_text
                    : "Erfahren Sie mehr"}
                </a>
              </Box>
            ) : null}
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default NewsDetail;
